import {getImageFileDimensions} from '../file/getImageFileDimensions';

export async function validateGalleryImage(blob) {
  if (!blob.type.startsWith('image')) {
    throw Error('The file is not an image!');
  }

  if (blob.size > 2097152) {
    throw Error('Maximum file size of 2MB exceeded!');
  }

  const {height, width} = await getImageFileDimensions(blob);
  if (height > 2000 || width > 2000) {
    throw Error('Maximum size of 2000x2000 pixels exceeded!');
  }
}
